import { connectAutoComplete } from 'react-instantsearch-dom'
import Results from './Results'

export default connectAutoComplete(Results)
